import parsePhoneNumber from 'libphonenumber-js'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { SvgEmail, SvgPhone } from '../icons'
import { BookingContactOwnerFragment } from '../../../../lib/graphql'

const BookingContactOwner = ({
  email,
  firstname,
  lastname,
  phone,
}: BookingContactOwnerFragment) => {
  const phoneNumber = parsePhoneNumber(phone || '', 'FR')?.formatInternational()
  return (
    <div className={s.contact}>
      <div className={s.title}>
        <FormattedMessage
          id='ui.BookingContactOwner.contactHost'
          defaultMessage='Contactez votre hôte'
        />
      </div>
      <div className={s.name}>{`${firstname} ${lastname}`}</div>
      <div className={s.phone}>
        <span className={s.icon}>
          <SvgPhone />
        </span>
        <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
      </div>
      <div className={s.email}>
        <span className={s.icon}>
          <SvgEmail />
        </span>
        <a href={`mailto:${email}`}>{email}</a>
      </div>
    </div>
  )
}

export default BookingContactOwner
